import { render, staticRenderFns } from "./ContactSearch.vue?vue&type=template&id=1fc558e3"
import script from "./ContactSearch.vue?vue&type=script&lang=ts"
export * from "./ContactSearch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports